import { useCallback, useEffect, useMemo, useState } from 'react';
import s from './home.module.scss'
import classNames from 'classnames'
import { endOfWeek, startOfWeek } from 'date-fns';
import { useProfile } from '@shared/api/useProfile';
import { useAnalytics } from '@shared/api/useAnalytics';
import { useTimeSlots } from '@features/schedule/api/useTimeSlots';
import { useAllAppointments } from '@entities/schedule/api/useAllAppointments';
import { useUpcomingAppointments } from '@entities/schedule/api/useUpcomingAppointments';
import { Alert } from '@shared/ui/alert/alert';
import { NextClassCard } from '@features/schedule/ui/next-class-card/next-class-card';
import { NotNextClassCard } from '@features/schedule/ui/not-next-class-card/not-next-class-сard';
import { Loader } from '@shared/ui/loader/loader';
import { PaymentAlert } from '@features/schedule/ui/payment-alert/payment-alert';
import { ClassesBoard } from '@widgets/schedule/ui/classes-board/classes-board';
import { ClosedClassesBoard } from '@widgets/schedule/ui/classes-board-closed/classes-board-closed';
import { TeacherHomeAnalytics } from '@widgets/teacher/ui/teacher-home-analytics';
import { FillProfileCard } from '@widgets/teacher/ui/fill-profile-card/fill-profile-card';
import { MobileClassBoard } from '@widgets/schedule/ui/mobile-class-board';
import useMedia from 'use-media';
import { PageTemplate } from '@shared/ui/page-template';
import { ConnectStudentModal } from '@features/teacher/connect-student';
import { VacationAlert } from '@features/profile/vacation';

export const TeacherHome = () => {
	const date = useMemo(() => new Date(), [])
	const isMobile = useMedia({maxWidth: '768px'})

	const [start_date, set_start_date] = useState();
  const [end_date, set_end_date] = useState();
	
	const {data: profile} = useProfile()
	const {data: analytics} = useAnalytics()
	const {data: timeslots, isLoading: isTimeslotsLoading} = useTimeSlots(true)

	const { data: appointments, isFetched: appointmentsIsFetched } =
    useAllAppointments({
      from: start_date?.toISOString(),
      to: end_date?.toISOString(),
    });
	const {data: upcoming, isFetched: isUpcomingFetched} = useUpcomingAppointments()

	const getFilledNumber = useCallback(() => {
		let result = 0
		if(profile?.name && profile?.teacher_bio && profile?.avatar?.image) result += 1
		if(profile?.signed_docs) result += 1
		if(timeslots?.length > 0) result += 1
		if(profile?.card_id) result += 1

		return result
	}, [profile, timeslots])

  const [filled, setFilled] = useState(getFilledNumber());

	const getCurrentWeekDates = useCallback(() => {
			const from = startOfWeek(new Date(date), {weekStartsOn: 1});
			const to = endOfWeek(new Date(date), {weekStartsOn: 1})

			set_start_date(from);
			set_end_date(to);
	}, [date]);

	useEffect(() => {
			getCurrentWeekDates();
	}, [getCurrentWeekDates]);


	useEffect(() => {
		if(!isTimeslotsLoading){
			setFilled(getFilledNumber())
		}
	}, [isTimeslotsLoading, getFilledNumber])

	return (
		<PageTemplate fullHeight title="Главная" titleClassName={s.pageTitle}>
			<ConnectStudentModal/>
			{profile?.access_level !== 'full' && 
			{'basic': '', 
			'restricted': <Alert title='Проверьте почту' subtitle='Подтвердите регистрацию, чтобы начать преподавать'/>}[profile?.access_level]}
			{profile?.vacation_enabled && <VacationAlert/>}
			<div className={s.page}>
				{filled < 4 ? 
					<FillProfileCard {...{profile, timeslots, isTimeslotsLoading, filled}}/> : 
					<div className={s.widgets}>
						<TeacherHomeAnalytics className={s.analytics} profile={profile} analytics={analytics}/>
						<div className={s.nextClassWrapper}>
							{profile?.card_num_masked ? 
								<>
									{isUpcomingFetched ? 
										(upcoming ? 
											<NextClassCard className={s.nextClassCard} role="teacher" {...upcoming}/> :
											<NotNextClassCard className={s.nextClassCard} role="teacher"/>) :
										<div className={s.nextClassLoader}>
											<Loader/>
										</div>
									}
								</>
							:
								<PaymentAlert/>
							}
						</div>
					</div>
				}
				{profile?.access_level !== 'restricted' ? 
					(isMobile ? 
					<MobileClassBoard {...{appointments, set_end_date, set_start_date, appointmentsIsFetched, start_date, end_date}} isTeacher={true}/> : 
					<ClassesBoard className={classNames(s.schedule, filled < 4 ? s.scheduleBlurred : '')} {...{appointments, set_end_date, appointmentsIsFetched, set_start_date, start_date, end_date}} isTeacher={true}/>) :
					<ClosedClassesBoard className={classNames(s.schedule, filled < 4 ? s.scheduleBlurred : '')} {...{set_end_date, set_start_date, start_date, end_date}} />}
			</div>
		</PageTemplate>
	)
}
